//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        sticky: {
            type: Boolean,
            default: false,
        },
        transparent: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        /** @return {string} */
        activeRouteSlug() {
            if (this.getRouteBaseName() === 'index' || this.getRouteBaseName() === 'profile') {
                return 'manage-account';
            }

            // Get path excluding leading slash and locale prefix.
            return this.$route.path.replace(/^\/(?:[a-z]{2}\/)?(.*)/, '$1');
        },
        /** @return {string} */
        tidalUrl() {
            return `${process.env.TIDAL_ORIGIN}/`;
        },
    },
    methods: {
        /**
         * @param {string} translationKey
         * @return {string | null} The translation.
         */
        getTranslation(translationKey) {
            const translation = /** @type {string} */ (this.$t(`webCommon.header.${translationKey}`));

            // Special case string that only have translation in some languages.
            // Make sure we don't return the translation key (default for
            // vue-i18n if string doesn't exist) and instead return null;
            if (translationKey === 'startFreeTrialShortText'
                && translation.endsWith('.startFreeTrialShortText')) {
                return null;
            }

            return translation;
        },
        login() {
            this.$tidalAuth.login({ extraAuthParams: { restrict_signup: 'true' } });
        },
        logout() {
            this.$tidalAuth.logout();
        },
    },
};
